import cx from 'classnames'
import { type CSSProperties, type ReactNode } from 'react'
import { type Config, usePopperTooltip } from 'react-popper-tooltip'

type TooltipProps = Pick<Config, 'placement' | 'trigger'> & {
  content: ReactNode
  children: ReactNode
  className?: string
  tooltipClassName?: string
  tooltipStyle?: CSSProperties
}

export default function Tooltip({
  content,
  children,
  placement,
  trigger,
  className,
  tooltipClassName,
  tooltipStyle,
}: TooltipProps) {
  const { getTooltipProps, setTooltipRef, setTriggerRef, visible } =
    usePopperTooltip({
      placement,
      trigger,
      interactive: true,
    })
  const { style, ...tooltipProps } = getTooltipProps()

  return (
    <>
      <div ref={setTriggerRef} className={className}>
        {children}
      </div>

      {visible && (
        <div
          ref={setTooltipRef}
          className={cx('opacity-95 z-20', tooltipClassName)}
          style={{
            ...tooltipStyle,
            ...style,
          }}
          {...tooltipProps}
        >
          {content}
        </div>
      )}
    </>
  )
}
